import tim from '../../tim'
import TIM from "tim-js-sdk"

const groupModules = {
    state: {
        groupList: [],
        currentMemberList: [],
        createGroupModelVisible: false,
        currentRoom: {},
        currentGroupNotification: undefined
    },
    getters: {
        hasGroupList: state => state.groupList.length > 0
    },
    mutations: {
        updateGroupNotification(state, notification) {
            state.currentGroupNotification = notification === 'close' ? undefined : notification;
        },
        updateGroupList(state, groupList) {
            state.groupList = groupList
        },
        updateCurrentRoom(state, room) {
            state.currentRoom = room;
        },
        updateCreateGroupModelVisible(state, visible) {
            state.createGroupModelVisible = visible
        },
        updateCurrentMemberList(state, memberList) {
            state.currentMemberList = [...state.currentMemberList, ...memberList]
        },
        deleteGroupMemeber(state, userID) {
            state.currentMemberList = state.currentMemberList.filter((member) => member.userID !== userID)
        },
        deleteGroupMemberList(state, userIDList) {
            state.currentMemberList = state.currentMemberList.filter((member) => !userIDList.includes(member.userID))
        },
        resetCurrentMemberList(state) {
            state.currentMemberList = []
        },
        reset(state) {
            Object.assign(state, {
                groupList: [],
                currentMemberList: [],
                createGroupModelVisible: false
            })
        }
    },
    actions: {
        updateGroupList(context, groupList) {
            context.commit('updateGroupList', groupList)
        },
        getGroupMemberList(context, groupID) {
            return tim.getGroupMemberList({
                groupID: groupID,
                offset: context.state.currentMemberList.length,
                count: 100
            }).then((imResponse) => {
                context.commit('updateCurrentMemberList', imResponse.data.memberList)
                return imResponse
            })
        },
        getGroupMemberListInterval(context, groupID) {
            return tim.getGroupMemberList({
                groupID: groupID,
                offset: 0,
                count: 100
            }).then((imResponse) => {
                context.commit('resetCurrentMemberList');
                context.commit('updateCurrentMemberList', imResponse.data.memberList)
                return imResponse
            })
        },
        getGroupProfile(context, groupID) {
            return tim.getGroupProfile({ groupID }).then(({data}) => {
                context.commit('updateGroupProfile', data.group);
                context.dispatch('getGroupMemberListInterval', groupID);
            });
        },
        findOrCreateGroup(context, groupID) {
            tim.searchGroupByID(groupID).then(({ data }) => {
                context.dispatch("joinGroup", data.group.groupID);
            }).catch(err => {
                context.dispatch("createGroup", groupID);
            });
        },
        createGroup(context, groupID) {
            tim.createGroup({
                type: TIM.TYPES.GRP_CHATROOM,
                name: groupID,
                groupID: groupID
            }).then(async ({ data }) => {
                await context.dispatch(
                    'checkoutConversation',
                    `GROUP${data.group.groupID}`
                )
            }).catch(error => {
                context.commit('showMessage', {
                    type: 'error',
                    message: error.message
                })
            })
        },
        joinGroup(context, groupID) {
            tim.joinGroup({ groupID })
                .then(async res => {
                    const status = res.data.status
                    switch (status) {
                        case TIM.TYPES.JOIN_STATUS_WAIT_APPROVAL:
                            context.commit('showMessage', {
                                message: '申请成功，等待群管理员确认。',
                                type: 'info'
                            })
                            break
                        case TIM.TYPES.JOIN_STATUS_SUCCESS:
                        case TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP:
                            await context.dispatch(
                                'checkoutConversation',
                                `GROUP${groupID}`
                            )

                            // 每分钟更新grouo
                            setInterval(() => {
                                context.dispatch('getGroupProfile', groupID);
                            }, 60000);
                            break
                        default: break
                    }
                }).catch(error => {
                    context.commit('showMessage', {
                        message: error.message,
                        type: 'error'
                    })
                })
        }
    }
}

export default groupModules
